"use client";
import PortalHome from "@/components/PortalHome";
import ShowPageWrapper from "@/components/ShowPageWrapper";

function getFirstPathSegment(): string | null {
  if (typeof window === "undefined") return null;
  const segs = window.location.pathname.split("/").filter(Boolean);
  return segs[0] || null;
}

export default function Page() {
  const slug = getFirstPathSegment();
  if (slug) {
    return <ShowPageWrapper />;
  }
  return <PortalHome />;
}
